module.exports = __webpack_public_path__ + "img/logistics-trajectory-receiver.ef48cc54.svg";